export default "https://cdn-static.gokick.com/assets/f4ff00fe02dd4df624a9917ee1bd81ca642b4b73/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";